module.exports = __webpack_public_path__ + "static/img/articledesign1.8fac742.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articledesign1.jpg
// module id = hRV7
// module chunks = 1